module.exports = __webpack_public_path__ + "static/media/america-tijuana.541d9c5c.jpg";